module.exports = __webpack_public_path__ + "img/icon-reset-sel.b429bd19.svg";